// extracted by mini-css-extract-plugin
module.exports = {"kidProfile":"kid-profiles_kidProfile__nCHqo","bubblePop":"kid-profiles_bubblePop__W61sr","kidProfileContainer":"kid-profiles_kidProfileContainer__E6e_f"};